<template>
  <div class="app-container">
    <header-choun />
    <div class="main-contents" :class="{ 'container': container }">
      <slot></slot>
    </div>
    <footer-choun></footer-choun>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { throttle } from 'throttle-debounce'
import * as types from '@/utvStore/store/mutation-types'
import HeaderChoun from '@/utvStore/components/ChounDiary/partials/HeaderChoun'
import FooterChoun from '@/utvStore/components/ChounDiary/partials/FooterChoun'

export default {
  name: 'AppContainerChoun',
  props: {
    data: Object,
    tokenFlg: String,
    showHeader: {
      type: Boolean,
      default: true
    },
    headerLayout: {
      type: String
    },
    container: {
      type: Boolean,
      default: true
    },
    preRegist: {
      type: Boolean,
      default: false
    },
    awsPrefix: {
      type: String,
      default: ''
    },
    isDrawer: {
      type: Boolean,
      default: false
    },
    pageName: {
      type: String,
      default: ''
    },
    sessionAccessToken: {
      type: String,
      default: ''
    },
    fromChoun: {
      type: Number,
      default: 0
    }
  },
  components: {
    HeaderChoun,
    FooterChoun,
  },
  computed: {
    ...mapGetters(['isLoggedIn']),
    ...mapState({
      accessToken: state => state.auth.accessToken,
      uiState: state => state.uiState
    })
  },
  watch:{
    uiState:{
      handler(n){
        if(this.isDrawer){
          this.bodyLock(n)
        }
      },
      deep: true
    }
  },
  mounted() {
    const mq = matchMedia('(min-width: 768px)');
    this.setDevice(mq)
    mq.addListener(this.setDevice)

    this.startWatchingScroll()
    /**
     * フロント (LocalStorage) と サーバー(Session) でのログイン状態の不整合の解消
     * tokenFlg が0(Sessionにログイン情報がない)の場合フロントのログイン情報を削除する
     **/
    if(this.fromChoun){
      //超運Dからの遷移だった場合は、ここでisLoggedIn（ログイン状態）をtrueにする
      this.$store.commit(types.SET_ACCESS_TOKEN, this.sessionAccessToken)
    }else{
      if (undefined !== typeof this.tokenFlg) {
        if (this.tokenFlg === '0' && this.isLoggedIn) {
          this.$store.dispatch(types.LOGOUT)
        } else if (this.tokenFlg == '1' && !this.isLoggedIn) {
          // storageからもトークンを消す
          this.$store.dispatch(types.LOGOUT).then(() => {
            location.href = `/user/logout`
          })
        }
      }
    }
  },
  methods: {
    startWatchingScroll: function() {
      document.addEventListener(
        'scroll',
        throttle(100, () => {
          const scrollTop =
            document.body.scrollTop || document.documentElement.scrollTop
          this.$store.commit(types.UPDATE_SCROLL_TOP, scrollTop)
        })
      )
    },
    bodyLock(uiState) {
      // bodyのスクロールを無効にする
      if(!this.uiState.isPc){
        if(uiState.showAccountModal || uiState.showDrawerMenu){
          document.body.style.overflow = 'hidden'
          document.body.style.position = 'fixed'
          document.body.style.width = '100%'
        }else{
          document.body.style.overflowX = 'hidden'
          document.body.style.overflowY = 'auto'
          document.body.style.position = 'static'
          document.body.style.width = 'auto'
        }
      }
    },
    setDevice(mq){
      this.$store.dispatch(types.IS_PC, mq.matches)
    }
  }
}</script>

<style lang="scss">
.app-container {
  font-family: dnp-shuei-mgothic-std, sans-serif;
  max-width: 580px;
  margin: 0 auto;
  background: #fff;
  min-height: 100vh;
  padding-top: 64px;
}
.app_logoutimg {
  width: 0;
  height: 0;
  display: block;
}
.main-contents {
  width: 100%;
  min-height: 100%;
}
.loading-font {
    visibility: hidden;
}
.wf-active, .loading-delay {
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/AppContainerChoun.vue